/**
 * Carries the entered organization's name across the hard navigation, so the page that loads
 * next can tell the user where they are.
 */
export const SWITCHED_ACCOUNT_NAME_KEY = 'account_switchedTo';
